import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useProducts, useProductSearch} from '@salesforce/commerce-sdk-react'
import ProductScroller from '../../../../product-scroller'
import {useGlobaleContext} from '../../../../../contexts/globale'

import useBrCategory from '../../../../../hooks/use-br-category'
import {SELECTED_ATTRIBUTES_WIDGET_PRODUCTS} from '../../../../../constants'

const TabItem = ({
    id,
    productsList = [],
    effectiveDateTime = '',
    categoryFilters = '',
    productShowName,
    customerGroupIds,
    productShowPrice,
    isViewed = false,
    enableBloomreachSearch = false,
    productShowColorSwatches,
    analyticsProps = {},
    showMetalLabel = false,
    lifeStyle = {}
}) => {
    const {countryISO, currencyCode} = useGlobaleContext()
    // SFCC fallback search
    const {isLoading: isSfccProductsLoading, data: sfccProductSearchResult} = useProductSearch(
        {
            parameters: {
                perPricebook: true,
                allVariationProperties: true,
                allImages: true,
                limit: 15,
                c_selectedCountry: countryISO,
                c_selectedCurrency: currencyCode,
                expand: [
                    'promotions',
                    'variations',
                    'prices',
                    'images',
                    'page_meta_tags',
                    'custom_properties',
                    'availability',
                    'represented_products'
                ],
                refine: [`cgid=${id}`]
            }
        },
        {enabled: !enableBloomreachSearch && !productsList.length}
    )

    // Bloomreach Category Search
    const {data: brProductSearchResult, isLoading: isBrProductsLoading} = useBrCategory({
        id,
        countryISO,
        currencyCode,
        categoryFilters,
        customerGroupIds,
        effectiveDateTime,
        enableBloomreachSearch: enableBloomreachSearch && !productsList.length
    })

    const {data: scapiProductsResponse} = useProducts(
        {
            parameters: {
                ids: productsList,
                expand: ['availability', 'links', 'promotions', 'images', 'prices', 'variations'],
                perPricebook: true,
                select: SELECTED_ATTRIBUTES_WIDGET_PRODUCTS,
                allVariationProperties: true,
                allImages: true,
                c_selectedCountry: countryISO,
                c_selectedCurrency: currencyCode
            }
        },
        {
            enabled: Boolean(productsList.length)
        }
    )

    const products =
        scapiProductsResponse?.data ||
        sfccProductSearchResult?.hits ||
        brProductSearchResult?.data ||
        []

    return (
        <Box
            sx={{
                'div[data-testid="product-scroller"]': {paddingTop: 0},
                '.swiper-wrapper.swiper-wrapper': {paddingLeft: '20px'},
                '.swiper-parent': {width: 'unset'}
            }}
        >
            <ProductScroller
                products={isViewed ? products : products?.slice(0, 5)} // If the category component is not yet viewed - just redner 5 tiles rather than 15.
                isLoading={isSfccProductsLoading || isBrProductsLoading}
                enableFavourite={true}
                hideArrows={false}
                showImageSlider={true}
                showName={productShowName}
                showPrice={productShowPrice}
                hideVariations={!productShowColorSwatches}
                sliderGroup="product"
                analyticsProps={analyticsProps}
                showMetalLabel={showMetalLabel}
                lifeStyle={lifeStyle}
            />
        </Box>
    )
}

TabItem.propTypes = {
    id: PropTypes.string,
    productsList: PropTypes.array,
    productShowName: PropTypes.bool,
    productShowPrice: PropTypes.bool,
    effectiveDateTime: PropTypes.string,
    categoryFilters: PropTypes.any,
    isViewed: PropTypes.bool,
    customerGroupIds: PropTypes.any,
    enableBloomreachSearch: PropTypes.bool,
    productShowColorSwatches: PropTypes.bool,
    analyticsProps: PropTypes.object,
    showMetalLabel: PropTypes.bool,
    lifeStyle: PropTypes.object
}

export default TabItem
